import { render, staticRenderFns } from "./logoImg.vue?vue&type=template&id=1d655a49&scoped=true&"
import script from "./logoImg.vue?vue&type=script&lang=js&"
export * from "./logoImg.vue?vue&type=script&lang=js&"
import style0 from "./logoImg.vue?vue&type=style&index=0&id=1d655a49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d655a49",
  null
  
)

export default component.exports